export default __webpack_public_path__ + "static/media/doc-active.88c3b5ec.svg";